import React from 'react';
import './CartModifierPrice.less';

import {convertPrice} from "helpers/format.helper";

export const CartModifierPrice = ({price}) => {
	return <span className="cart-modifier-price">{convertPrice(price)}</span>;
};
